import React from "react";
import { PageHero } from "../components/site/kit";

const SECTIONS = [
  {
    id: "privacy",
    title: "Privacy Policy",
    body: [
      "SWITCH collects only the information you choose to share through our forms, including your name, email, company, phone number and a description of your growth problem. We use this information solely to respond to your enquiry and to improve how we help businesses grow.",
      "We do not sell your data. Information is retained only for as long as it is relevant to your enquiry and is then deleted. You may request access to, correction of, or deletion of your information at any time by writing to hello@switchnow.in.",
    ],
  },
  {
    id: "terms",
    title: "Terms of Use",
    body: [
      "By using this website you agree to use it lawfully and not to misuse any content, tools or forms provided. All content, including the SWITCH name, marks, frameworks and written material, is the property of SWITCH and may not be reproduced without permission.",
      "The material on this site is provided for general information and does not constitute professional advice. SWITCH is not liable for decisions taken on the basis of website content alone. Engagements are governed by a separate agreement.",
    ],
  },
  {
    id: "cookies",
    title: "Cookie Policy",
    body: [
      "We use a small number of cookies to understand how the site is used and to improve your experience. Essential cookies keep the site working; analytics cookies help us understand which content is useful.",
      "You can accept or decline non-essential cookies using the banner shown on your first visit, and you can change your browser settings to manage cookies at any time. Declining non-essential cookies will not affect access to the site.",
    ],
  },
];

export default function Legal() {
  return (
    <div className="font-body bg-white">
      <PageHero
        testId="legal-hero"
        eyebrow="Legal"
        title={<>Privacy, terms<br />and <span className="text-[#5f8f10]">cookies.</span></>}
        subcopy="Everything covering how we handle your information and how this site may be used, in one place."
      />

      <section className="bg-[#F7F6F2]">
        <div className="mx-auto max-w-[1360px] px-6 py-16 md:px-12 md:py-24 lg:px-16">
          <nav className="mb-12 flex flex-wrap gap-2">
            {SECTIONS.map((s) => (
              <a key={s.id} href={`#${s.id}`} className="font-body border border-black/20 px-4 py-2 text-sm font-semibold uppercase tracking-[0.1em] text-black/70 transition-colors hover:border-[#5f8f10] hover:text-[#5f8f10]">{s.title}</a>
            ))}
          </nav>
          <div className="border-t border-black/15">
            {SECTIONS.map((s) => (
              <div key={s.id} id={s.id} className="scroll-mt-28 border-b border-black/15 py-14 md:grid md:grid-cols-12 md:gap-10">
                <div className="md:col-span-4">
                  <p className="font-body text-sm font-semibold uppercase tracking-[0.18em] text-[#5f8f10]">{s.title}</p>
                </div>
                <div className="md:col-span-8">
                  {s.body.map((p, i) => (
                    <p key={i} className="font-body mb-5 max-w-2xl text-lg font-normal leading-relaxed text-black/80">{p}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p className="font-body mt-8 text-sm font-normal uppercase tracking-[0.1em] text-black/50">Last updated June 2026. Questions? Write to hello@switchnow.in.</p>
        </div>
      </section>
    </div>
  );
}
